import React from 'react';
import { motion } from 'framer-motion';
import { CommandCenter } from '../../components/CommandCenter';
import { SEO } from '../../components/SEO';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { FadeIn } from '../../components/FadeIn';
import { AnimatedText } from '../../components/AnimatedText';

const springConfig = {
  type: "spring",
  stiffness: 50,
  damping: 20,
  mass: 1
};

export const DailyIntelligence = () => {
  return (
    <div className="space-y-8">
      <SEO
        title="Daily Business Intelligence | ProfitIQ.AI"
        description="Get real-time business insights and AI-powered analytics to make data-driven decisions and optimize your business performance."
      />
      
      <Breadcrumbs
        items={[
          { label: 'Products', href: '/products' },
          { label: 'Daily Business Intelligence' }
        ]}
      />

      <FadeIn>
        <AnimatedText
          text="Real-Time Business Intelligence Dashboard"
          el="h1"
          className="text-4xl font-bold mb-4 bg-gradient-to-r from-amber-200 to-amber-400 text-transparent bg-clip-text"
        />
        <p className="text-gray-400 text-lg mb-8">
          Monitor your business performance in real-time with AI-powered insights and predictive analytics.
        </p>
      </FadeIn>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ...springConfig }}
      >
        <CommandCenter />
      </motion.div>
    </div>
  );
};